//#region IMPORT
import React, { useEffect, useMemo, useState } from 'react';
import M_FILE_CUSTOM_01 from './M_FILE_CUSTOM_01';
import Global from '../../../../Services/Common/Global';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_FILE_CUSTOM_01_Query';
import {
  buildDocumentFileUrl,
  getContentIndexByCurOrder,
  getStepContents,
} from '../../../ToolBoxMeeting/BASIC/hook/tbmContents';
//#endregion

const STEP_CODE = 'TBM_DOCS';

function M_FILE_CUSTOM_01F() {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState(null);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);
  const [contentData, setContentData] = useState([]);
  const [contentIndex, setContentIndex] = useState(0);
  const { navigate } = useAppNavigate();

  const stepContents = useMemo(
    () => getStepContents(contentData, STEP_CODE),
    [contentData]
  );

  const currentFile = useMemo(
    () => stepContents[contentIndex],
    [stepContents, contentIndex]
  );
  //#endregion

  //#region 이벤트
  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  useEffect(() => {
    const path = currentFile?.filePath;
    setRenderPreview(null);

    if (!path) {
      setFullUrl(undefined);
      return;
    }

    const fileUrl = buildDocumentFileUrl(path, Global.file.useUrl);
    setFullUrl(fileUrl);
    setRenderPreview(fileUrl);
    setNumPages(undefined);
    setPageNumber(Number(currentFile?.lastPosition) || 1);
  }, [currentFile?.filePath, currentFile?.lastPosition]);
  //#endregion

  //#region 쿼리
  useSearch1({
    onSuccess: async (rows) => {
      const contents = rows?.[0]?.contents ?? [];
      console.log('contents', contents);
      setContentData(contents);
      setContentIndex(getContentIndexByCurOrder(contents, STEP_CODE));
    },
  });
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const onDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total);
  };

  const HandleContentTabChange = (index) => {
    if (index === contentIndex) return;
    const target = stepContents[index];
    const lastPosition = Number(target?.lastPosition) || 1;
    setContentIndex(index);
    setNumPages(undefined);
    setPageNumber(lastPosition);
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      navigate('/Home');
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };
  //#endregion

  return (
    <M_FILE_CUSTOM_01
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      contentFiles={stepContents}
      contentIndex={contentIndex}
      onContentIndexChange={HandleContentTabChange}
    />
  );
}

export default M_FILE_CUSTOM_01F;
